import { composeValueSet } from "@intocare/datatypes/lib/value-set";

import { MEASURE_TYPE } from "../../code-system/measure-type";

export const ISOLATION_MEASURE_TYPE_DISPLAY = composeValueSet({
	name: "ISOLATION_MEASURE_TYPE_DISPLAY",
	description: "Current selection of measure types for displaying isolation evaluations.",
	system: MEASURE_TYPE,
	include: [
		"CONTACT_PRECAUTION_PROCEDURE",
		"DROPLET_PRECAUTION_PROCEDURE",
		"AIRBORNE_PRECAUTION_PROCEDURE",
		"STRICT_MEASURE",
		"PROTECTION_PROCEDURE",
	],
});
